/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type AppointmentSlotStatus = (typeof AppointmentSlotStatus)[keyof typeof AppointmentSlotStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppointmentSlotStatus = {
  planned: 'planned',
  available: 'available',
  completed: 'completed',
} as const;
